import { useParams } from "react-router-dom";

export function withRouter(Component: any) {
    return (props: any) => {
        const params = useParams();
        return <Component {...props} params={params} />;
    };
}